export default __webpack_public_path__ + "static/media/someoneLikeYouThumbnail.3b26c83d.jpg";